document.addEventListener('DOMContentLoaded', function () {
  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  // Refresh ScrollTrigger after fonts/images load (prevents miscalculated positions)
  window.addEventListener('load', function () {
    ScrollTrigger.refresh();
  });
});
